import {
    SET_INVOICE_LIST,
    SET_INVOICE_LOADING,
    SET_INVOICE_SEARCH_NUMBER,
} from "../actionTypes";
import { initialState } from "../initialState";

const invoiceSearchReducer = (state = initialState.invoiceSearch, action) => {
    switch (action.type) {
        case SET_INVOICE_SEARCH_NUMBER:
            return {
                ...state,
                invoiceNumber: action.payload,
            };

        case SET_INVOICE_LIST:
            return {
                ...state,
                invoiceList: action.payload,
            };
        case SET_INVOICE_LOADING:
            return {
                ...state,
                invoiceIsLoading: action.payload,
            };
        default:
            return state;
    }
};

export default invoiceSearchReducer;
